/* eslint-disable no-bitwise */
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import * as english from '@assets/i18n/en-US.json';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { SsrLoader } from './ssr-loader';

const hashCode = (s) => s.split('').reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);

export function createTranslateLoader(http: HttpClient, platformId: any, translations: any) {
  if (isPlatformBrowser(platformId)) {
    return new TranslateHttpLoader(http, './assets/i18n/', `.json?hash=${getHash()}`);
  } else {
    return new SsrLoader(translations);
  }
}

export function getHash() {
  return hashCode(JSON.stringify(english));
}
